"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from "react";
import { Pagination } from "@/components/ui/pagination";
interface ProducersTablePaginationProps {
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
  prefetchNextPage?: (() => void) | null;
  updateSearchParams: (updates: Record<string, string | string[]>) => void;
}
export function ProducersTablePagination(t0) {
  const $ = _c(22);
  const {
    total,
    limit,
    offset,
    hasMore,
    prefetchNextPage,
    updateSearchParams
  } = t0;
  const currentPage = Math.floor(offset / limit) + 1;
  const baseTotalPages = total > 0 ? Math.ceil(total / limit) : 1;
  const totalPages = hasMore ? Math.max(baseTotalPages, currentPage + 1) : Math.max(baseTotalPages, 1);
  const rawStart = total === 0 ? 0 : Math.min(offset + 1, Math.max(total, 1));
  const rawEnd = total === 0 ? 0 : Math.min(offset + limit, total);
  const startDisplay = Math.min(rawStart, rawEnd);
  const endDisplay = Math.max(rawEnd, startDisplay);
  const totalLabel = hasMore ? `${total}+` : `${total}`;
  let t1;
  if ($[0] !== hasMore || $[1] !== prefetchNextPage) {
    t1 = () => {
      if (hasMore && prefetchNextPage) {
        prefetchNextPage();
      }
    };
    $[0] = hasMore;
    $[1] = prefetchNextPage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleNextPageHover = t1;
  let t2;
  let t3;
  if ($[3] !== hasMore || $[4] !== prefetchNextPage || $[5] !== totalPages) {
    t2 = () => {
      if (hasMore && prefetchNextPage && totalPages > 1) {
        const timer = setTimeout(() => {
          prefetchNextPage();
        }, 2000);
        return () => clearTimeout(timer);
      }
    };
    t3 = [hasMore, prefetchNextPage, totalPages];
    $[3] = hasMore;
    $[4] = prefetchNextPage;
    $[5] = totalPages;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== endDisplay || $[9] !== startDisplay || $[10] !== totalLabel) {
    t4 = <div className="text-muted-foreground tabular-nums">Mostrando {startDisplay} até {endDisplay} de {totalLabel} produtores</div>;
    $[8] = endDisplay;
    $[9] = startDisplay;
    $[10] = totalLabel;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== updateSearchParams) {
    t5 = page => {
      updateSearchParams({
        page: page.toString()
      });
    };
    $[12] = updateSearchParams;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== currentPage || $[15] !== handleNextPageHover || $[16] !== t5 || $[17] !== totalPages) {
    t6 = <Pagination currentPage={currentPage} onNextPageHover={handleNextPageHover} onPageChange={t5} showTextLabels={true} totalPages={totalPages} />;
    $[14] = currentPage;
    $[15] = handleNextPageHover;
    $[16] = t5;
    $[17] = totalPages;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t4 || $[20] !== t6) {
    t7 = <div className="flex flex-wrap items-center justify-between gap-2">{t4}{t6}</div>;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}